<script setup lang="ts">
// swiper 组件
import { Swiper, SwiperSlide } from 'swiper/vue';
// swiper css
import 'swiper/css';
import type { SwiperClass } from 'swiper/react';

const { data: newsList } = await useApiFetchPolicyNews()
const curIndex = ref(0)

const curItem = computed(() => {
  return newsList.value?.[curIndex.value]
})

function isActive(id: number) {
  return id === curItem.value.id
}

// 轮播数据：共 6 块，icon/title/content/url 具体内容待填
interface BlockItem {
  id: number
  icon: string
  label: string
  title: string
  content: string
  url: string
  bg: string       // 默认态背景图
  activeBg: string // active 态背景图
}

// :src 绑定需拼 baseURL（站点部署在 /web 前缀），参考 block4 的做法
const appBaseUrl = useRuntimeConfig().app.baseURL

const swiperAssets = '/img/home/block2-swiper'
const baseList: BlockItem[] = [
  { id: 1, icon: `${swiperAssets}/图标1.png`, label: '中文域名落地方案：', title: '让中文品牌名成为可访问入口', content: '客户记得住「中国地砖」，未必记得住一串字母域名。中文域名的价值不在稀缺，而在把客户已经说出口的中文名，变成能直接打开、能直接下单的地址；它单独存在时只是一个跳转符号，只有与人工智能商城同域落地，才构成完整的品牌入口。北京国信诚商互联网科技有限公司在交付自有域名商城时，通常把中文域名、英文域名与主站做 301 归一，避免同一批商品页出现多份副本。', url: 'https://aiscpt.cn/web/news/1860', bg: `${swiperAssets}/常态背景.png`, activeBg: `${swiperAssets}/选中背景1.png` },
  { id: 2, icon: `${swiperAssets}/图标2.png`, label: '中文域名接入：', title: '解析、证书、跳转与一致性', content: '中文域名打不开，八成不是域名的问题，而是解析、证书、跳转、备案四环里缺了一环。地址栏里输入的「中国地砖.商城」，在系统内部会转换成以 xn-- 开头的 Punycode 编码，所以 HTTPS 证书必须覆盖编码后的域名，否则一律提示不安全。本文按接入顺序给出四步配置、五类故障对照与六项自检清单，并说明域名、站名、公司全称、备案号四处实体信息如何保持一致。', url: 'https://aiscpt.cn/web/news/1859', bg: `${swiperAssets}/常态背景.png`, activeBg: `${swiperAssets}/选中背景2.png` },
  { id: 3, icon: `${swiperAssets}/图标3.png`, label: '企业自建平台落地方案：', title: '从商品结构到自有域名的四步', content: '企业建线上平台，决定成败的不是页面好不好看，而是三件事：域名是不是自己的、后台是不是自己能改、数据是不是沉淀在自己系统里。路径可以拆成四步——先定归属，再梳理商品结构，再确定参数体系，最后排出客户决策路径并落成系统。北京国信诚商互联网科技有限公司的人工智能商城按这一路径交付，2026 年已完成交付的行业商城已覆盖 20 余个行业领域。', url: 'https://aiscpt.cn/web/news/1858', bg: `${swiperAssets}/常态背景.png`, activeBg: `${swiperAssets}/选中背景3.png` },
  { id: 4, icon: `${swiperAssets}/图标4.png`, label: '行业平台落地方案：', title: '一个行业一套参数体系的搭法', content: '行业平台与企业商城的差别不在商品多少，而在结构宽度：前者要把一个行业的选品逻辑讲清，后者只需把一家的商品讲透。建筑陶瓷看空间、规格、工艺与防滑等级，交通安全设施看材质、反光性能与安装方式，羊绒服饰看成分比例与纱支等级，三套分类树无法互相套用。本文给出参数体系的三步搭法：采集行业术语、聚类决策维度、映射为筛选器。', url: 'https://aiscpt.cn/web/news/1857', bg: `${swiperAssets}/常态背景.png`, activeBg: `${swiperAssets}/选中背景4.png` },
  { id: 5, icon: `${swiperAssets}/图标5.png`, label: '平台技术架构总结：', title: '七个能力层怎么分工', content: '人工智能商城不是一套模板，而是七个能力层的组合：入口层、站点呈现层、商品结构层、交易履约层、内容与智能能力层、运营后台层、数据与权限层。其中商品结构层决定其余各层的形态——新增一个行业是配置完成还是重新开发，全看这一层。平台以多租户方式承载多个行业站点，站点配置、商品与订单、账号权限、数据导出四处做隔离，企业的数据才确实沉淀在自己的空间里。', url: 'https://aiscpt.cn/web/news/1856', bg: `${swiperAssets}/常态背景.png`, activeBg: `${swiperAssets}/选中背景5.png` },
  { id: 6, icon: `${swiperAssets}/图标6.png`, label: '应用场景总结：', title: '四类场景与判断标准', content: '判断一个行业适不适合做人工智能商城，看两个变量：商品参数复杂度与客户决策链长度。两个变量交叉出四类场景——参数型采购看筛选器，规格型选品看搭配，体验型消费看内容，服务型交易看流程。每类要解决的问题不同，商城该重点做哪一屏也不同。本文同时给出三类不适合以商城形态承载的情况：纯展示需求、超低频大宗交易、无标准化商品的服务。', url: 'https://aiscpt.cn/web/news/1861', bg: `${swiperAssets}/常态背景.png`, activeBg: `${swiperAssets}/选中背景6.png` },
]
// 视口约可见 5.9 块，loop 要求 slide 数明显多于可见数，
// 6 块渲染两遍（12 块）保证循环缓冲充足、每次拖拽稳定滑动 1 格
const blockList = [...baseList, ...baseList].map(item => ({
  ...item,
  icon: `${appBaseUrl}${item.icon}`,
  bg: `${appBaseUrl}${item.bg}`,
  activeBg: `${appBaseUrl}${item.activeBg}`,
}))

// 动态背景图（路径来自数据，无法用 glx-bg-img mixin），效果与 mixin 一致：100% 100% 平铺
function bgStyle(bg: string) {
  return bg ? {
    backgroundImage: `url("${bg}")`,
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 0',
  } : undefined
}

// 进度条滑块：固定宽 795px，在 996px 轨道上随 active 块平移
const PROGRESS_TRACK_WIDTH = 996
const PROGRESS_THUMB_WIDTH = 795
const thumbOffset = ref(0)

// active 态按钮跳转（url 为外部完整链接，navigateTo 必须声明 external，否则不生效）
function toUrl(url: string) {
  if (url) navigateTo(url, { external: true })
}

// 编号补零，如 1 -> 01
function padNum(n: number) {
  return String(n).padStart(2, '0')
}

// 视口规则：swiper.activeIndex 为视口最左可见块，左起第 3 块为 active，最左/最右两块半透明
function updateSwiperVisual(swiper: SwiperClass) {
  const firstVisible = swiper.activeIndex
  swiper.slides.forEach((slideEl, domIndex) => {
    const el = slideEl as HTMLElement
    const isActivePos = domIndex === firstVisible + 2
    const isEdge = domIndex === firstVisible || domIndex === firstVisible + 5
    el.style.opacity = isEdge ? '0.6' : (domIndex > firstVisible && domIndex < firstVisible + 5) ? '1' : ''
    el.classList.toggle('is-active-item', isActivePos)
  })

  // loop 会重排 DOM，从 active 位元素自身读 data-idx（1~6）计算滑块位置
  const activeEl = swiper.slides[firstVisible + 2] as HTMLElement | undefined
  const dataIdx = Number(activeEl?.dataset.idx ?? 1)
  thumbOffset.value = (dataIdx - 1) / (baseList.length - 1) * (PROGRESS_TRACK_WIDTH - PROGRESS_THUMB_WIDTH)
}

function onSwiperAfterInit(swiper: SwiperClass) {
  updateSwiperVisual(swiper)
}

function onSwiperActiveIndexChange(swiper: SwiperClass) {
  updateSwiperVisual(swiper)
}

// 点击 slide：把点击的块滑到 active 位（视口左起第 3 块），点击 active 块自身（含"查看详情"按钮）不动作
// 注意：loop 下 DOM 含复制块且会被重排，slideTo(activeIndex + delta) 多次点击后目标会被钳制到数组末端而失效，
// 必须用 slideToLoop 按真实 index 换算（内部自动处理 loopFix 环绕）
function onSwiperClick(swiper: SwiperClass) {
  const clickedIndex = swiper.clickedIndex
  if (clickedIndex === undefined || clickedIndex === null) return
  if (clickedIndex === swiper.activeIndex + 2) return
  const clickedEl = swiper.slides[clickedIndex] as HTMLElement | undefined
  const dataIdx = Number(clickedEl?.dataset.idx)
  if (!dataIdx) return
  // active 位为左起第 3 块：让 (dataIdx - 2) 环绕后的块成为最左可见块
  const total = baseList.length
  const leftRealIdx = ((dataIdx - 1 - 2) % total + total) % total
  swiper.slideToLoop(leftRealIdx)
}

// 过渡结束（loop 的 DOM 重排 loopFix 已完成、索引已修正）后重算一次，
// 修正 active-index-change 触发过早导致的 active/半透明位置偏移
function onSwiperTransitionEnd(swiper: SwiperClass) {
  updateSwiperVisual(swiper)
}
</script>

<template>
  <section class="block2">
    <div class="block2Container">
      <div class="titleBlock">
        <div class="floor1">
          <div class="text">
            开展<em>“人工智能+”</em>行动
          </div>
          <img class="iconArrow" src="/img/home/block2-进入.png" alt="">
        </div>
        <div class="floor2">
          <div class="text">
            行业结构先行 · 自有域名 · 自有平台 · 自主运营
          </div>
        </div>
        <div class="floor3">
          <div class="text">
            Artificial Intelligence
          </div>
        </div>
      </div>

      <div class="bannerBlock">
        <div class="outerRightTop">
          <div class="text">
            企业 · 行业 · 人工智能商城
          </div>
        </div>

        <div class="titleBlock">
          <div class="text1Col">
            <div class="text1">
              关于我们
            </div>
          </div>

          <div class="text2Col">
            <div class="text2">
              About Us
            </div>
          </div>

        </div>

        <div class="leftBlock">
          <div class="floor1">
            <div class="text">
              让<em>人工智能商城</em>，装下每个行业
            </div>
          </div>
          <div class="floor2">
            <div class="text">
              为响应国家<em>“人工智能+”行动</em>号召，国信诚商自研人工智能商城平台系统，内置商业智能体，把企业相关的商品结构、交易流程与 AI
              智能商城系统装进同一套商城系统，让企业在AI赋能加持下，更精准高效的锁定客户和推广宣传企业的商品。
            </div>
          </div>
          <div class="line1"></div>
          <div class="floor3">
            商家可以通过AI一键生成文案、图片、视频，让商品得到更好的展示和销售；买家也可以通过AI交互系统智能化选品购物，更便捷快速的买到心仪的商品。通过这套人工智能解决方案，让供需两端连接得更紧密，为企业运营降本增效。
          </div>
        </div>
        <div class="rightBlock">
          <div class="floor1">
            <div class="left">
              人工智能商城平台
            </div>
            <div class="right">
              针对于各个行业的不同特性
            </div>

          </div>
          <div class="floor2">
            <div class="text">
              国信诚商提供专业化AI赋能+行业平台落地解决方案：
            </div>
          </div>

          <div class="line1"></div>

          <div class="floor3">
            <div class="text">
              先梳理该行业的商品结构与选购逻辑，确定分类与参数体系，再搭建对应的人工智能商城平台，完成行业AI智能体系统部署与商城平台的完美契合。
            </div>
          </div>

          <div class="floor4">
            <div class="text">
              商城上线后，商家即可利用AI智能体系统，一键上新与推广，轻松实现高效运营。
            </div>
          </div>

          <div class="floor5">
            <div class="text">
              方案已覆盖服装、食品、3C数码、建材、百货、零售、农副产品、文旅周边等多个行业，让每个行业都拥有属于自己的AI智能化商城，为行业的高速稳定发展提供新质生产力。
            </div>
          </div>

        </div>


      </div>

      <div class="swiperBlock">
        <div class="glxSwiper">
          <swiper class="mySwiper" slides-per-view="auto" :space-between="7" loop @after-init="onSwiperAfterInit"
            @active-index-change="onSwiperActiveIndexChange" @slide-change-transition-end="onSwiperTransitionEnd"
            @click="onSwiperClick">
            <swiper-slide v-for="(item, index) in blockList" :key="index" :data-idx="item.id">
              <!-- 默认态布局（具体布局待填） -->
              <div class="layoutDefault" :style="bgStyle(item.bg)">
                <div class="iconFloor">
                  <img class="icon" :class="`icon${item.id}`" :src="item.icon" alt="">
                </div>
                <div class="labelFloor">
                  <div class="label">{{ item.label }}</div>
                </div>
                <div class="titleFloor">
                  <div class="title">{{ item.title }}</div>
                </div>
                <div class="line1"></div>
                <div class="contentFloor">
                  <div class="content">{{ item.content }}</div>
                </div>

                <div class="numBlock">
                  <div class="text1">{{ padNum(item.id) }}</div>
                  <div class="text2">/</div>
                  <div class="text3">{{ padNum(baseList.length) }}</div>
                </div>
              </div>
              <!-- active 态布局：背景图、白字、按钮等（具体布局待填） -->
              <div class="layoutActive" :style="bgStyle(item.activeBg)">
                <div class="labelFloor">
                  <div class="label">{{ item.label }}</div>
                </div>
                <div class="titleFloor">
                  <div class="title">{{ item.title }}</div>
                </div>
                <div class="line1"></div>
                <div class="contentFloor">
                  <div class="content">{{ item.content }}</div>
                </div>

                <div class="numBlock">
                  <div class="text1">{{ padNum(item.id) }}</div>
                  <div class="text2">/</div>
                  <div class="text3">{{ padNum(baseList.length) }}</div>
                </div>

                <div class="btnFloor">
                  <div class="btn" @click="toUrl(item.url)">
                    <div class="text">
                      查看详情
                    </div>
                    <img class="iconArrow" src='/img/home/block2-swiper/按钮箭头.png' alt="">
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div class="progressBar">
          <div class="thumb" :style="{ transform: `translateX(${thumbOffset}px)` }"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
section.block2 {
  height: 1370px;

  >.block2Container {
    width: 1920px;
    height: 100%;
    background: #E8E8EF;
    border-radius: 10px;

    >.titleBlock {
      height: 201px;
      box-sizing: border-box;
      padding-top: 57px;
      padding-left: 359px;

      >.floor1 {
        display: flex;
        align-items: center;

        >.text {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 38px;
          color: #000000;
          line-height: 1;

          em {
            color: rgba(22, 40, 209, 1);
          }
        }

        >.iconArrow {
          width: 37px;
          height: 20px;
          display: block;
          margin-left: 20px;
          object-fit: contain;
        }
      }

      >.floor2 {
        margin-top: 20px;

        >.text {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 28px;
          color: #3B3B3B;
          line-height: 1;
        }
      }

      >.floor3 {
        margin-top: 27px;

        >.text {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #9D9D9D;
          line-height: 1;
          text-transform: uppercase;
        }
      }
    }

    >.bannerBlock {
      // 原图 1755×422，按 418px 高度等比换算宽约 1735px（原 17350px 疑似多写一个 0）
      width: 1735px;
      height: 418px;
      box-shadow: 0px 1px 3px 0px rgba(25, 32, 123, 0.17);
      margin-left: auto;
      margin-right: auto;

      // 站点部署在 /web 前缀（NUXT_APP_BASE_URL），CSS 图片路径必须带 /web 前缀，统一走 glx-bg-img
      @include glx-bg-img("/img/home/block2-banner背景.png");

      position: relative;
      z-index: 0;
      display: flex;

      >.outerRightTop {
        width: 828px;
        height: 44px;

        @include glx-bg-img("/img/home/block2-banner右上背景.png");
        // background-position: 0px 3px;

        position: absolute;
        z-index: 1;
        top: -44px;
        right: 0;

        box-sizing: border-box;
        padding-left: 37px;
        padding-top: 11px;

        >.text {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 22px;
          color: #FFFFFF;
          line-height: 1;
        }
      }

      >.titleBlock {
        width: 235px;
        height: 62px;
        background: #276EFF;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 266px;

        display: flex;
        box-sizing: border-box;
        padding-left: 11px;
        padding-right: 14px;

        >.text1Col {
          box-sizing: border-box;
          padding-top: 18px;

          >.text1 {
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 28px;
            color: #FFFFFF;
            line-height: 1;
          }
        }

        >.text2Col {
          box-sizing: border-box;
          margin-left: auto;
          padding-top: 28px;

          >.text2 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 1;

            text-transform: uppercase;
          }
        }
      }

      >.leftBlock {
        box-sizing: border-box;
        padding-top: 107px;

        >.floor1 {
          margin-left: 280px;

          >.text {
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 1;

            em {
              color: rgba(39, 110, 255, 1);
            }
          }
        }

        >.floor2 {
          margin-top: 28px - 4px;
          margin-left: 281px;

          >.text {
            width: 529px;
            font-family: Source Han Sans CN;
            font-weight: 300;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 22px;

            em {
              color: rgba(235, 184, 46, 1);
            }
          }
        }

        >.line1 {
          width: 499px;
          height: 1px;
          background: #EBB82E;
          margin-top: 16px;
          margin-left: 276px;
        }

        >.floor3 {
          width: 474px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 22px;

          box-sizing: border-box;
          margin-top: 14px;
          margin-left: 281px;
        }
      }

      >.rightBlock {
        box-sizing: border-box;
        padding-top: 97px;
        margin-left: 127px;

        >.floor1 {
          display: flex;

          align-items: center;

          transform: translateX(-5px);

          >.left {
            width: 155px;
            height: 28px;
            background: #F36916;

            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 28px;
            text-align: center;
          }

          >.right {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 1;
            margin-left: 14px;
          }
        }

        >.floor2 {
          margin-top: 12px;

          >.text {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 1;
          }
        }

        >.line1 {
          width: 539px;
          height: 1px;
          background: #F36916;
          margin-top: 19px;
        }

        >.floor3 {
          margin-top: 18px;

          >.text {
            max-width: 532px;
            font-family: Source Han Sans CN;
            font-weight: 300;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 22px;
          }
        }

        >.floor4 {
          >.text {
            max-width: 532px;
            font-family: Source Han Sans CN;
            font-weight: 300;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 22px;

            margin-top: 20px;
          }
        }

        >.floor5 {
          margin-top: 20px;

          >.text {
            max-width: 534px;
            font-family: Source Han Sans CN;
            font-weight: 300;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 22px;
          }
        }
      }
    }

    >.swiperBlock {
      width: 1735px;
      margin-top: 19px;
      margin-left: auto;
      margin-right: auto;

      >.glxSwiper {
        height: 596px;

        :deep(.mySwiper) {
          height: 100%;
          cursor: default; // 覆盖 swiper 默认的 grab 抓手光标，悬停保持正常箭头

          .swiper-slide {
            width: 286px;
            height: 596px;
            transition: opacity 0.3s;

            // 两套布局：默认态 / active 态，通过 .is-active-item 切换显隐
            >.layoutDefault,
            >.layoutActive {
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              border-radius: 10px;
              overflow: hidden;


            }

            >.layoutDefault {
              background: #D9DCE8; // 占位底色，待设计稿替换
              box-sizing: border-box;
              padding-top: 64px;
              position: relative;
              z-index: 0;

              // icon / title / content 具体布局待填
              >.iconFloor {
                >.icon {
                  display: block;
                  object-fit: contain;

                  &.icon1 {
                    width: 89px;
                    height: 86px;
                    margin-left: 22px;
                  }

                  &.icon2 {
                    width: 80px;
                    height: 91px;
                    margin-left: 26px;
                  }

                  &.icon3 {
                    width: 74px;
                    height: 92px;
                    margin-left: 22px;
                  }

                  &.icon4 {
                    width: 88px;
                    height: 91px;
                    margin-left: 17px;
                  }

                  &.icon5 {
                    width: 88px;
                    height: 92px;
                    margin-left: 18px;
                  }

                  &.icon6 {
                    width: 84px;
                    height: 87px;
                    margin-left: 25px;
                  }
                }
              }

              >.labelFloor {
                margin-top: 33px;
                margin-left: 28px;

                >.label {
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 18px;
                  color: #4D4D53;
                  line-height: 1;

                }
              }

              >.titleFloor {
                margin-left: 28px;

                >.title {
                  margin-top: 14px;
                  max-width: 200px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  font-size: 28px;
                  color: #1A1A1C;
                  line-height: 36px;
                }
              }

              >.line1 {
                margin-left: 28px;
                width: 28px;
                height: 5px;
                background: #5864DA;
                margin-top: 55px;
              }

              >.contentFloor {
                margin-left: 28px;
                margin-top: 31px;

                >.content {
                  max-width: 234px;
                  font-family: Source Han Sans CN;
                  font-weight: 300;
                  font-size: 16px;
                  color: #787879;
                  line-height: 24px;

                  // 3 行超出省略
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                  line-clamp: 3;
                  overflow: hidden;
                }
              }

              >.numBlock {
                position: absolute;
                z-index: 1;
                right: 16px;
                bottom: 24px;
                display: flex;
                align-items: flex-end;

                >.text1 {
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 36px;
                  color: #1B1B1B;
                  line-height: 1;
                }

                >.text2 {
                  transform: translateY(2px);
                }

                >.text2,
                >.text3 {
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 22px;
                  color: #1B1B1B;
                  line-height: 1;
                  opacity: 0.6;
                }
              }
            }

            >.layoutActive {
              display: none;
              box-sizing: border-box;
              padding-top: 78px;

              // 背景图、白字、按钮等具体布局待填
              >.labelFloor {
                margin-left: 25px;

                >.label {
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 18px;
                  color: #FFFFFF;
                  line-height: 1;
                }
              }

              >.titleFloor {
                margin-left: 25px;
                margin-top: 17px;

                >.title {
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  font-size: 28px;
                  color: #FFFFFF;
                  line-height: 36px;
                }
              }

              >.line1 {
                width: 28px;
                height: 5px;
                background: #FFFFFF;
                margin-left: 25px;
                margin-top: 55px;
              }

              >.contentFloor {
                margin-top: 31px;
                margin-left: 26px;

                >.content {
                  max-width: 240px;
                  font-family: Source Han Sans CN;
                  font-weight: 300;
                  font-size: 16px;
                  color: rgba(255, 255, 255, 0.8);
                  line-height: 24px;

                  // 3 行超出省略
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                  line-clamp: 3;
                  overflow: hidden;
                }
              }

              >.numBlock {
                display: flex;
                align-items: flex-end;
                margin-left: 27px;
                margin-top: 57px;

                >.text1 {
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 36px;
                  color: #FFFFFF;
                  line-height: 1;
                }

                >.text2 {
                  transform: translateY(2px);
                }

                >.text2,
                >.text3 {
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  font-size: 22px;
                  color: rgba(255, 255, 255, 0.6);
                  line-height: 1;
                }
              }

              >.btnFloor {
                margin-top: 100px;
                display: flex;
                justify-content: center;
                cursor: pointer; // 容器层兜底，整块悬浮均为手型

                >.btn {
                  width: 121px;
                  height: 39px;
                  background: #1628D1;
                  border-radius: 19px;
                  border: 1px solid #FFFFFF;

                  display: flex;
                  align-items: center;

                  box-sizing: border-box;
                  padding-left: 22px;
                  cursor: pointer !important; // !important 防止运行时内联样式覆盖

                  &:hover {
                    cursor: pointer !important; // !important 防止运行时内联样式覆盖
                  }

                  >.text {
                    cursor: pointer;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 39px;
                  }

                  >.iconArrow {
                    cursor: pointer;
                    width: 17px;
                    height: 13px;
                    display: block;
                    object-fit: contain;
                    margin-left: 6px;
                  }
                }
              }
            }

            &.is-active-item {
              >.layoutDefault {
                display: none;
              }

              >.layoutActive {
                display: block; // 可按布局改为 flex
                box-shadow: 0px 6px 49px 0px rgba(12, 19, 101, 0.32);
              }
            }
          }
        }
      }

      // 轮播进度条：轨道 996px，滑块固定 795px 随 active 块平移
      >.progressBar {
        width: 996px;
        height: 4px;
        background: #D5D5DF;
        border-radius: 2px;
        margin: 72px auto 0;
        position: relative;

        >.thumb {
          position: absolute;
          top: 0;
          left: 0;
          width: 795px;
          height: 100%;
          background: rgba(22, 40, 209, 1);
          border-radius: 2px;
          transition: transform 0.3s; // 与轮播过渡同步
        }
      }
    }
  }
}
</style>